export default __webpack_public_path__ + "static/image-1ddb1663a2637663b6afbc25f782107f.png";